export default __webpack_public_path__ + "static/qr-code-85bb71fb0acd34d7541666cbc0de52cc.png";